const { debounce, getElement, getElements } = window.BAO.Utils
class SiteLookbook extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.BEFORE_ADD_FROM_FORM,
      () => {
        getElements('.lkb-Hotspot-active').forEach(el => {
          el.classList.remove('lkb-Hotspot-active')
        })
        this.classList.remove('lkb-HotspotBackdrop-active')
      },
    )
  }
}

customElements.define('site-lookbook', SiteLookbook)

class LookbookMedia extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    if (
      typeof this.els['drawer-trigger'] === 'undefined' ||
      this.els['drawer-trigger'].exists === false
    ) { return }

    this.els['drawer-trigger'].element.addEventListener(
      'click',
      this.buildDrawer.bind(this),
    )
  }

  buildDrawer () {
    let html = ''

    if (!this.lookbookContainer || !this.lookbookDrawerContent) return

    const lookbookCards = getElements('[data-lookbook-media-el="card"]', {
      context: this,
    })

    lookbookCards.forEach(el => {
      html += `<div class="sec-Lookbook_DrawerCard">${el.outerHTML}</div>`
    })

    this.lookbookDrawerContent.innerHTML = html
  }

  get lookbookContainer () {
    return this.closest('[data-lookbook-el="container"]')
  }

  get lookbookDrawerContent () {
    return this.lookbookContainer
      ? getElement('[data-lookbook-drawer-el="content"]', {
        context: this.lookbookContainer,
      })
      : false
  }
}

customElements.define('lookbook-media', LookbookMedia)

class LookbookHotspot extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
    this.positionTooltips()
  }

  setupListeners () {
    super.setupListeners()

    window.addEventListener('resize', () => {
      debounce(() => {
        this.positionTooltips()
      }, 200)
    })

    this.els.toggle.element.addEventListener('click', () => {
      this.classList.toggle('lkb-Hotspot-active')
      this.lookbookContainer?.classList.toggle(
        'lkb-HotspotBackdrop-active',
        this.classList.contains('lkb-Hotspot-active'),
      )
    })

    this.els.close.element.addEventListener('click', () => {
      this.classList.remove('lkb-Hotspot-active')
      this.lookbookContainer?.classList.remove('lkb-HotspotBackdrop-active')
    })

    document.body.addEventListener('click', e => {
      if (
        !this.contains(e.target) &&
        this.classList.contains('lkb-Hotspot-active')
      ) {
        this.classList.remove('lkb-Hotspot-active')
        this.lookbookContainer?.classList.remove('lkb-HotspotBackdrop-active')
      }
    })
  }

  positionTooltips () {
    this.removeAttribute('data-tooltip-position')

    const tooltip = this.els.tooltip

    if (!tooltip.exists) return

    const containerRect = this.externalEls.grid.element.getBoundingClientRect()
    const tooltipRect = tooltip.element.getBoundingClientRect()
    const position = tooltipRect.right > containerRect.width ? 'left' : 'right'

    this.setAttribute('data-tooltip-position', position)
  }

  get lookbookContainer () {
    return this.closest('[data-lookbook-el="container"]')
  }
}

customElements.define('lookbook-hotspot', LookbookHotspot)

class LookbookForm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))

    this.onSelectChange = this.onSelectChange.bind(this)

    if (this.els?.select?.exists) {
      this.els.select.elements.forEach(el => {
        this.listeners.add(el, 'change', this.onSelectChange)
      })
    }

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.CHANGED,
      this.onCartChanged.bind(this),
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.PUSH_CART.ERROR,
      this.onCartError.bind(this),
    )
  }

  onSelectChange (e) {
    this.els.variant.element.value = e.target.value
    this.addToCart()
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  onSubmitHandler (e) {
    e.preventDefault()

    this.addToCart()
  }

  addToCart () {
    if (this.dataset.loading === 'true') return

    if (this.els?.select?.exists) {
      this.els.select.elements.forEach(el => {
        el.value = ''
      })
    }

    if (this.silent === true) {
      this.setButtonText(window.theme.strings.loading)
      this.dataset.loading = 'true'
    }

    window.BAO.Cart.addItemFromForm(this.form, {}, this.silent)
  }

  onCartChanged (event) {
    if (event.detail.form === this.form && this.silent === true) {
      delete this.dataset.loading

      this.setButtonText(window.theme.strings.added)
    }
  }

  onCartError (event) {
    if (event.detail.form === this.form && this.silent === true) {
      delete this.dataset.loading

      this.setButtonText(window.theme.strings.error)
    }
  }

  setButtonText (text) {
    this.els['button-label'].elements.forEach(el => {
      el.innerText = text
    })
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }

  get silent () {
    return this.dataset.silent === 'true'
  }
}

customElements.define('lookbook-form', LookbookForm)
